//
// Entity classification
//

export const ENTITYTYPE_DOCUMENT_NAME = "entity_types";

export const ENTITYTYPE_RECORD_TYPE = "lookup";
export const ENTITYTYPE_RECORD_SUBTYPE = "entity";

export const ENTITYTYPE_RECORD = {
    name: "",
    description: "",
    countries: [],
    sequence: 0
};

